import React, { useEffect, useState } from "react";
import styles from "./ForgotPassword.module.css";
import Modal from "../../Atoms/Modal/Modal";
import ModalChildrenContainer from "../../Atoms/Modal/ModalChildrenContainer";
import Buttons from "../../Atoms/Buttons/Buttons";
import { toast } from "react-toastify";
import { useForgotPassword } from "../../../Hooks/Authentication";
import TextInput from "../../Atoms/Inputs/TextInput";
import emailicon from "../../../assets/Imagess/emailinputicon.svg";

const UserModal = ({ handleOnClose, title }) => {
  //------------------------------------------------------
  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const { mutate: forgotPassword, isLoading: isForgotLoading } =
    useForgotPassword();
  function isValidEmail(email) {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const handleForgotSubmit = (email) => {
    if (isValidEmail(email)) {
      forgotPassword(email, {
        onSuccess: (data) => {
          toast.success("Reset Email has been sent");

          window.location.href = "/";
        },
        onError: (error) => {
          toast.error("Unregistered Email Address");
          setError(true);
        },
      });
    } else {
      toast.error("Enter valid Email");
    }
  };
  //------------------------------------------------------

  return (
    <Modal
      onClose={handleOnClose}
      title={title}
      width="44rem"
      scrollY="auto"
      closeWhite={false}
    >
      <ModalChildrenContainer>
        <div className={`${styles["modalRow"]} `}>
          <h3 className={`${styles["text"]}`}>
            {"Please enter your email to request a password reset."}
          </h3>
        </div>

        <div className={`${styles["modalRow"]}   `}>
          <div className={styles["w-100"]}>
            <TextInput
              icon={emailicon}
              width="100%"
              label="Email"
              name="email"
              type={"email"}
              value={email}
              placeholder={"Enter Email"}
              onChange={(e, value) => {
                setEmail(value);
              }}
            />
          </div>
        </div>

        <div className={`${styles["footer-container"]}`}>
          {" "}
          <Buttons
            text="Cancel"
            handleOnClick={() => {
              handleOnClose();
            }}
            rounded
            color={"#A6A6A6"}
            width={"49%"}
            style={{ fontFamily: "BukraBold", padding: "15px" }}
          />
          {"   "}
          <Buttons
            text="Send Reset Password"
            handleOnClick={() => {
              handleForgotSubmit(email);
              // handleOnClose();
            }}
            rounded
            color={"#0DA06E"}
            width={"49%"}
            style={{ fontFamily: "BukraBold", padding: "15px" }}
          />
        </div>
      </ModalChildrenContainer>
    </Modal>
  );
};

export default UserModal;
